
  import { defineComponent, ref, onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import Editor from '@tinymce/tinymce-vue';
  import axios from 'axios';

  export default defineComponent({
    name: 'blogs-content',
    components: {
      editor: Editor,
      Form,
    },

    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const route = useRoute();
      const { can } = useAbility();
      const submitButton = ref<HTMLButtonElement | null>(null);
      const blogData = ref<any>(null);
      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('blogContentUpdating'), [
          translate('blogs'),
        ]);
      });

      const { data } = await store.dispatch(Actions.GET_BLOG, route.params.id);
      blogData.value = data.data;
      const loading = ref(false);

      const contentEn = ref(blogData.value.contentEn);
      const contentAr = ref(blogData.value.contentAr);

      const goBack = () => {
        router.back();
      };

      const handleImageUpload = (blobInfo, success, failure) => {
        const formData = new FormData();
        formData.append('media', blobInfo.blob(), blobInfo.filename());

        axios
          .post(`blogs/uploadContentMedia/${route.params.id}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            const imageUrl = response.data?.data?.images;
            console.log(response.data.data);

            if (imageUrl) {
              success(imageUrl);
            } else {
              failure('Image URL not returned from server');
            }
          })
          .catch((error) => {
            console.error('Upload failed:', error);
            failure('Image upload failed: ' + error.message);
          });
      };

      const onSubmitUpdate = async () => {
        if (submitButton.value) {
          // eslint-disable-next-line
        submitButton.value!.disabled = true;
          submitButton.value.setAttribute('data-kt-indicator', 'on');
        }

        await store.dispatch(Actions.UPDATE_BLOG_CONTENT, {
          id: route.params.id,
          data: {
            contentAr: blogData.value.contentAr,
            contentEn: blogData.value.contentEn,
          },
        });
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];

        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
          //Deactivate indicator
          submitButton.value?.removeAttribute('data-kt-indicator');
          // eslint-disable-next-line
        submitButton.value!.disabled = false;
        } else {
          Swal.fire({
            text: translate('SUCCESSFULLY_UPDATED_BLOG'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          }).then(() => {
            router.push({ name: 'blogs-listing' });
          });
        }
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        translate,
        goBack,
        submitButton,
        onSubmitUpdate,
        contentEn,
        contentAr,
        loading,
        can,
        blogData,
        handleImageUpload,
      };
    },
  });
